import { UserProfile, Level } from "../../models";

export const getPointsToNextLevel = (levels: Level[], userProfile: UserProfile): number => {
    const { level, points } = userProfile;

    const currLevel = levels.find(systemLevel => systemLevel.level === level);
    const nextLevel = levels.find(systemLevel => systemLevel.level === level + 1);
    
    if (!nextLevel || !currLevel) {
        return 0
    }

    return nextLevel.startNumber - points;
}